import styled from 'styled-components';
import { Apple16New } from 'ui/icons';
import { colors, spacing } from 'ui/theme';
import { Tooltip } from 'ui/tooltip';
import { pxToRem } from 'utils/convert';

const RestrictionBadgeContainer = styled.span`
  border: ${pxToRem(1)} solid ${colors.grey15};
  border-radius: ${spacing.quarter};
  padding: ${spacing.eighth} ${spacing.half};
  height: 100%;
  display: table;
  text-align: center;
`;

type RestrictionBadgeProps = {
  text: string;
  hasTooltip?: boolean;
  tooltipText?: string;
};

export const RestrictionBadge = ({
  text,
  hasTooltip = false,
  tooltipText,
}: RestrictionBadgeProps) => {
  return (
    <Tooltip isEnabled={!!hasTooltip} tooltipContent={tooltipText}>
      <RestrictionBadgeContainer>
        <Apple16New color={colors.secondaryText} title="ios-icon">
          {text}
        </Apple16New>
      </RestrictionBadgeContainer>
    </Tooltip>
  );
};
